import { Component, Inject, ViewChild } from '@angular/core';

import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FilesAttachmentComponent } from '../files-attachment/files-attachment.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-files-attachment-modal',
    imports: [MatDialogModule, MatButtonModule, FilesAttachmentComponent, MatIconModule],
    template: `
    <div class="modal-container">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <h2 mat-dialog-title>Pièces jointes</h2>
        <button mat-icon-button mat-dialog-close focusable="false" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-dialog-content>
        <app-files-attachment [files]="data.files"></app-files-attachment>
      </mat-dialog-content>
      <mat-dialog-actions align="end" style="border-top: 1px solid #e0e0e0;">
        <button mat-button mat-dialog-close>Fermer</button>
        <button mat-flat-button color="primary" (click)="downloadAll()">Télécharger</button>
      </mat-dialog-actions>
    </div>
  `,
    styles: [
        `
      :host {
        display: block;
        min-width: 500px;
      }
      .modal-container {
        border-top: 8px solid #0b2559;
      }
      mat-dialog-content {
        min-height: 200px;
      }
    `
    ]
})
export class FilesAttachmentModalComponent {
  @ViewChild(FilesAttachmentComponent) filesAttachment: FilesAttachmentComponent;

  constructor(
    public dialogRef: MatDialogRef<FilesAttachmentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { files: any[] }
  ) {}

  downloadAll(): void {
    this.filesAttachment.downloadAllFiles();
  }
}
